export const SESSION_HEADER = 'sessionid';
export interface Session {
  sessionId: string;
  balanceTTLInSeconds: number;
  transactionStatus: string;
}